import generateClient from '../utils/generateClient';
import cache from './cache';

export default generateClient('account-api', cache);
